import { DOM_EVENTS } from "../constants/html-constants.es6.js";

export default class Element {
  _parentElement;

  _selector;

  _inclusive;

  /**
   * Gets the jQuery object for the element(s) defined by the current wrapper
   * selector and selector.
   *
   * @return {jQuery} the jQuery object
   */
  get #$() {
    if (this._parentElement) {
      const $parentElement = this._parentElement.$();

      if (this._inclusive) {
        return $parentElement.find(this._selector).addBack(this._selector);
      }

      return $parentElement.find(this._selector);
    }

    return window.jQuery(this._selector);
  }

  /**
   * Determines whether or not the current element is rendered on the page.
   *
   * @return {boolean} whether or not the current element is rendered on the page
   */
  get isRendered() {
    return this.$().length > 0;
  }

  /**
   * Represents an single element or multiple elements, defined by the provided
   * selector, that fall within the provided wrapper selector.
   *
   * @constructor
   * @param {Element} parentElement the parent element, if any
   * @param {string} selector the selector for the target element
   * @param {boolean} inclusive whether or not to include the parent element in
   * the search for the provided selector
   */
  constructor({ parentElement, selector, inclusive = false }) {
    this._parentElement = parentElement;
    this._selector = selector;
    this._inclusive = inclusive;
  }

  /**
   * Gets the jQuery object for the element(s) defined by the current wrapper
   * selector and selector.
   *
   * @param {number} index the instance to search for
   * @return {jQuery} the jQuery object
   */
  $(index) {
    if (index || index === 0) {
      return this.#$.eq(index);
    }

    return this.#$;
  }

  /**
   * Runs the provided function when the element(s) defined by the current
   * wrapper selector and selector are rendered on the page.
   *
   * @param {function(Event):void} func the function to run when the element is
   * rendered
   */
  onRendered(func) {
    window.jQuery(window).on(DOM_EVENTS.LOAD, () => {
      if (this.#$.length) {
        func();
      }
    });
  }
}
